<template>
    <div>
      <div class="d-flex justify-content-between">
        <h1 class="page-header">{{ $t('studentScoreSheet.pageTitle') }}</h1>
        <ts-breadcrumb
          :items="[
            { text: $t('toHomePage'), href: '/' },
            {
              text: $t('studentScoreSheet.pageTitle'),
              active: true
            }
          ]"
        />
      </div>
      <ts-card>
        <ts-card-wrapper>
          <div class="row">
            <div class="col-md-3">
              <ts-loading-banner :loading="loading">
                <div class="card border-0">
                  <div
                    class="card-body"
                    style="background-color: #20252a; border-radius: 5px"
                  >
                    <div class="text-gray-500">
                      <b>{{ $t('studentScoreSheet.filterCriteria') }}</b>
                    </div>
                  </div>
                  <div class="widget-list rounded-bottom">
                    <div class="row form-group mt-2">
                      <div class="col-md-12">
                        <label class="required">{{
                          $t('cashCollectionByCashier.branchName')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model.number="model.branch_id"
                          :options="branches"
                          :show-search="true"
                          :filter-option="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                        >
                        </a-select>
                        <div class="validate" v-if="errors.has('branch_id')">
                          {{ errors.first('branch_id') }}
                        </div>
                      </div>
                    </div>
  
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label class="required">{{
                          $t('studentScoreSheet.mainProgram')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model.number="model.acp_id"
                          :options="main_programs"
                          :show-search="true"
                          :filter-option="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          @change="onMainProgramChange"
                        ></a-select>
                        <div class="validate" v-if="errors.has('acps_id')">
                          {{ errors.first('acps_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label class="required">{{
                          $t('studentScoreSheet.subProgram')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model.number="model.acps_id"
                          :options="sub_programs"
                          :show-search="true"
                          :filter-option="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          @change="onSubChange"
                          :disabled="!model.acp_id"
                        ></a-select>
                        <div class="validate" v-if="errors.has('acps_id')">
                          {{ errors.first('acps_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label class="required">{{
                          $t('studentScoreSheet.acYear')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model.number="model.ac_year_id"
                          :options="ac_year_list"
                          :loading="fetching_academic_year"
                          @change="acYearChange"
                        ></a-select>
                        <div class="validate" v-if="errors.has('ac_year_id')">
                          {{ errors.first('ac_year_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label class="required">{{
                          $t('studentScoreSheet.acTerm')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model.number="model.ac_term_id"
                          :options="acTerms"
                          :show-search="true"
                          :loading="fetching_academic_term"
                          :filter-option="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                          @change="acTermChange"
                        ></a-select>
                        <div class="validate" v-if="errors.has('ac_term_id')">
                          {{ errors.first('ac_term_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label class="required">{{
                          $t('studentScoreSheet.classOperation')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model="model.class_id"
                          :options="class_options"
                          :show-search="true"
                          :placeholder="$t('all')"
                          :loading="fetching_class_operation"
                          :filter-option="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                        ></a-select>
                        <div class="validate" v-if="errors.has('class_id')">
                          {{ errors.first('class_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row form-group">
                      <div class="col-md-12">
                        <label class="required">{{
                          $t('studentScoreSheet.session')
                        }}</label>
                        <a-select
                          style="width: 100%"
                          v-model="model.session_id"
                          :options="sessionList"
                          :show-search="true"
                          :filter-option="
                            (input, option) =>
                              option.componentOptions.children[0].text
                                .toLowerCase()
                                .indexOf(input.toLowerCase()) >= 0
                          "
                        ></a-select>
                        <div class="validate" v-if="errors.has('session_id')">
                          {{ errors.first('session_id') }}
                        </div>
                      </div>
                    </div>
                    <div class="row">
                      <div class="col-md-12 text-center">
                        <ts-button
                          class="btn-block"
                          color="primary"
                          @click.prevent="preview"
                          :waiting="waiting"
                          >{{ $t('preview') }}</ts-button
                        >
                      </div>
                    </div>
                  </div>
                </div>
              </ts-loading-banner>
            </div>
            <div class="col-md-9">
              <ts-preview-pdf v-model="waiting" :src="src" />
            </div>
          </div>
        </ts-card-wrapper>
      </ts-card>
    </div>
  </template>
  <script>
  import { mapActions } from 'vuex'
  import { Errors } from 'form-backend-validation'
  
  export default {
    name: 'studentScoreSheet',
    data() {
      return {
        loading: false,
        waiting: false,
        fetching_academic_year: false,
        fetching_academic_term: false,
        fetching_class_operation: false,
        src: '',
        errors: new Errors(),
        branches: [],
        ac_year_list: [],
        main_programs: [],
        sub_programs: [],
        ac_terms: [],
        class_options: [],
        sessionList: [
        {
          value: 1,
          label: 'Session 1'
        },
        {
          value: 2,
          label: 'Session 2'
        }
        ],
        model: {
          branch_id: null,
          session_id: null,
          ac_year_id: null,
          ac_term_id: null,
          acp_id: null,
          acps_id: null,
          class_id: null
        }
      }
    },
    computed: {
      acTerms() {
        return this.ac_terms
      }
    },
    created() {
      this.fetchData()
    },
    methods: {
      ...mapActions('reportAcademic', [
        'studentScoreSheet',
        'getBranch',
        'getYear',
        'getMainProgram',
        'getSubProgram',
        'getTerm',
        'getClass'
      ]),
      // Fetch Data
      async fetchData() {
        this.loading = true
        await this.getBranch().then(response => {
          this.branches = response.data.map(el => ({
            value: el.branch_id,
            label: el.branch_name_en
          }))
        })
        await this.getMainProgram()
          .then(response => {
            this.main_programs = response.data
              .map(el => ({
                value: el.acp_id,
                label: el.acp_name_foreign
              }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.loading = false
            this.model.branch_id = this.$store.state.authUser.default_branch_id
            this.model.acp_id = this.main_programs[0].value
            this.model.session_id = this.sessionList[0].value
            if(this.model.acp_id){
              this.getSubProgram({
                filter: {
                  acp_id: this.model.acp_id
                }
                })
                .then(response => {
                  this.sub_programs = response.data.map(el => ({
                    value: el.acps_id,
                    label: el.acps_name_foreign
                  }))
                })
                .catch(error => {
                  this.$toasted.error(error.message)
                })
                .finally(() => {
                  this.loading = false
                  this.model.acps_id = this.sub_programs[0].value
                  if(this.model.acps_id){
                    this.getTerm({
                      filter: {
                        acps_id: this.model.acps_id,
                        ac_year_id: this.model.ac_year_id,
                        branch_id: this.model.branch_id,
                        ac_status_id: '1,2,3',
                      }
                      })
                      .then(response => {
                        this.ac_terms = response.data.map(
                          el => ({
                            value: el.ac_term_id,
                            ac_status_id: el.ac_status_id,
                            label:  el.term_name +
                              (el.ac_status_id == 1
                                ? ' ( Current ) '
                                : el.ac_status_id == 2
                                ? ' ( History ) '
                                : '( Next )')
                                  })
                                )
                      })
                      .catch(error => {
                        this.$toasted.error(error.message)
                      })
                      .finally(() => {
                        this.loading = false
                        this.ac_terms.filter(el => el.ac_status_id == 1).map(el => 
                        this.model.ac_term_id = el.value
                        )
                        if(this.model.ac_term_id){
                          this.getClass({
                            filter: {
                              ac_term_id: this.model.ac_term_id,
                              branch_id: this.model.branch_id
                            }
                          })
                            .then(response => {
                              this.class_options = response.data.map(el => ({
                                value: el.class_id,
                                label:
                                  el.class_name +
                                  ' | ' +
                                  el.teacher.full_name_en +
                                  ' | ' +
                                  el.academic_study_time.study_time
                              }))
                            })
                            .catch(error => {
                              this.$toasted.error(error.message)
                            })
                            .finally(() => {
                              this.fetching_class_operation = false
                              this.model.class_id = this.class_options[0].value
                            })
                        }
                      })
                  }
                })
            }
            if(this.model.branch_id){
              this.getYear({
                filter: {
                  branch_id: this.model.branch_id,
                  ac_status_id: '1,2,3',
                }
                })
                .then(response => {
                  this.ac_year_list = response.data.map(
                    el => ({
                      value: el.ac_year_id,
                      ac_status_id: el.ac_status_id,
                      label:
                        el.ac_year +
                        (el.ac_status_id == 1
                          ? ' ( Current ) '
                          : el.ac_status_id == 2
                          ? ' ( History ) '
                          : ' ( Next ) ')
                          })
                  )
                })
                .catch(error => {
                  this.$toasted.error(error.message)
                })
                .finally(() => {
                  this.loading = false
                  this.ac_year_list.filter(el => el.ac_status_id == 1).map(el => 
                    this.model.ac_year_id = el.value
                  )
                })
            }
          })
      },
      //onChange branch
      onBranchChange() {
        this.model.ac_year_id = null
        this.model.acps_id = null
        this.model.ac_term_id = null
        this.fetching_academic_year = true
        this.getYear({
          filter: {
            ac_status_id: '1,2,3',
            branch_id: this.model.branch_id
          },
          branch_id: [this.model.branch_id]
        })
          .then(response => {
            this.ac_year_list = _.sortBy(response.data, ['ac_status_id']).map(
              el => ({
                value: el.ac_year_id,
                label:
                  el.ac_year +
                  (el.ac_status_id == 1
                    ? ' ( Current ) '
                    : el.ac_status_id == 2
                    ? ' ( History ) '
                    : ' ( Next ) ')
              })
            )
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetching_academic_year = false
          })
      },
      //onMainProgramChange
      async onMainProgramChange(acp_id) {
        this.model.acps_id = null
        await this.getSubProgram({
          filter: {
            acp_id: acp_id
          }
        })
          .then(response => {
            this.sub_programs = response.data.map(el => ({
              value: el.acps_id,
              label: el.acps_name_foreign
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.loading = false
          })
      },
      //onSubChange
      onSubChange(acps_id) {
        this.model.ac_term_id = null
        this.model.class_id = null
        if (this.model.ac_year_id) {
          this.fetching_academic_term = true
          this.getTerm({
            filter: {
              acps_id: acps_id,
              ac_status_id: '1,2,3',
              ac_year_id: this.model.ac_year_id,
              branch_id: this.model.branch_id
            },
            branch_id: [this.model.branch_id]
          })
            .then(response => {
              this.ac_terms = response.data.map(el => ({
                value: el.ac_term_id,
                label:
                  el.term_name +
                  (el.ac_status_id == 1
                    ? ' ( Current ) '
                    : el.ac_status_id == 2
                    ? ' ( History ) '
                    : '( Next )')
              }))
            })
            .catch(error => {
              this.$toasted.error(error.message)
            })
            .finally(() => {
              this.fetching_academic_term = false
            })
        }
      },
      //acYearChange
      acYearChange() {
        // this.model.acps_id = null
        this.model.ac_term_id = null
        this.model.class_id = null
        this.fetching_academic_term = true
        this.getTerm({
          filter: {
            acps_id: this.model.acps_id,
            ac_status_id: '1,2,3',
            ac_year_id: this.model.ac_year_id,
            branch_id: this.model.branch_id
          },
          branch_id: [this.model.branch_id]
        })
          .then(response => {
            this.ac_terms = response.data.map(el => ({
              value: el.ac_term_id,
              label:
                el.term_name +
                (el.ac_status_id == 1
                  ? ' ( Current ) '
                  : el.ac_status_id == 2
                  ? ' ( History ) '
                  : '( Next )')
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetching_academic_term = false
          })
      },
      //acTermChange
      acTermChange(ac_term_id) {
        this.fetching_class_operation = true
        this.model.class_id = null
        this.getClass({
          filter: {
            ac_term_id: ac_term_id,
            branch_id: this.model.branch_id
          },
          branch_id: [this.model.branch_id]
        })
          .then(response => {
            this.class_options = response.data.map(el => ({
              value: el.class_id,
              label:
                el.class_name +
                ' | ' +
                el.teacher.full_name_en +
                ' | ' +
                el.academic_study_time.study_time
            }))
          })
          .catch(error => {
            this.$toasted.error(error.message)
          })
          .finally(() => {
            this.fetching_class_operation = false
          })
      },
      preview() {
        this.waiting = true
        this.src = ''
        this.errors = new Errors()
        this.studentScoreSheet(this.model)
          .then(response => {
            this.src = response.url
          })
          .catch(error => {
            this.$toasted.error(error.message)
            this.errors = new Errors(error.errors)
          })
          .finally(() => {
            this.waiting = false
          })
      }
    },
    watch: {
      'model.branch_id': function(val) {
        if (val) {
          this.onBranchChange()
        }
      }
    }
  }
  </script>
  